"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeUtils = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _timeData = require("./time-data");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TimeUtils = exports.TimeUtils = {
  parseDate: function parseDate(stringDate) {
    var date = new Date(stringDate);
    var y = (0, _moment.default)(date).get('year');
    var m = (0, _moment.default)(date).get('month') + 1; // adding one to make it non-zero based months
    var d = (0, _moment.default)(date).get('date');
    return {
      y: y,
      m: m,
      d: d
    };
  },
  createTimeHashFromKey: function createTimeHashFromKey(key) {
    return {
      h: _timeData.TimeMap[key].h,
      m: _timeData.TimeMap[key].m,
      time_index: key
    };
  },
  scheduleHash: function scheduleHash(startOrEnd, date, timeIndex) {
    var schedule = {};
    var dateHash = date ? {
      date: this.parseDate(date)
    } : {};
    var timeHash = timeIndex ? {
      time: this.createTimeHashFromKey(timeIndex)
    } : {};
    schedule[startOrEnd] = _objectSpread(_objectSpread({}, dateHash), timeHash);
    return schedule;
  }
};